<template>
<div class="pb-5">
  <Topnav/>
  <div class="container content">
    <Loading :active.sync="isLoading" :color="loaderColor"></Loading>
    <div class="my-5">
      <div class="row">
        <div class="col-md-3"></div>
        <div class="col-md-6 bg-light py-3 mt-5">
          <div class="form-group">
            <label for="botId">Bot API Token</label>
            <input type="text" ref="token" v-model="token" v-on:keydown.enter="createBot" class="form-control" placeholder="Bot API Token">
            <small id="bottokenHelp" class="form-text text-muted">You can get your bot API Token from
              <a href="https://t.me/botfather" target="blank">@BotFather</a> in Telegram </small>
          </div>
          <button @click="createBot" class="btn btn-block btn-outline-success" :disabled='isDisabled'>Create New Bot</button>
        </div>
        <div class="col-md-3"></div>
      </div>
    </div>

    
    <div class="text-center my-3 border-bottom border-info">
      <h4>Current Plan</h4>
    </div>
    <Plan/>

    <div v-if="bots.length > 0" class="text-center my-3 border-bottom border-info">
      <h4>My Bots</h4>
    </div>
    <div class="row mb-5">
      <BotCard v-for="bot in bots" :bot="bot" :key="bot.token" @deleteBot="deleteBot"></BotCard>
    </div>
  </div>
</div>
</template>


<script>
// @ is an alias to /src
import BotCard from '@/components/BotCard.vue'
import Topnav from "@/components/Topnav.vue";
import Plan from "@/components/Plan.vue";


import ApiService from '@/services/ApiService'
import TelegramService from '@/services/TelegramService'

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import structure from "@/assets/js/defaultBot.js";


export default {
  name: 'bots',
  components: {
    BotCard,
    Loading,
    Topnav,
    Plan
  },
  data: function() {
    return {
      token: "",
      isDisabled: false,
      user: this.$store.state.user,
      bots: this.$store.state.bots,
      isLoading: false,
      loaderColor: 'black',
      structure: structure,
      CREATE_MSG: `Your bot is created with the example Template, Edit your bot as your 
      requirement or select from available Templates.`
    }
  },
  methods: {
    createBot() {
      if (this.token.trim() == ""){
        this.$dialog.alert('Please Enter Bot Token!').then(function() {
          this.$refs.token.focus();
        }.bind(this));
        return false;
      } else {
        for (var i = 0; i < this.bots.length; i++) {
          if (this.bots[i].token == this.token) {
            this.$dialog.alert('Bot with The Given Token Is Already Present!').then(function() {
              this.$refs.token.focus();
              this.$refs.token.value = "";
            }.bind(this));
            return false;
          }
        }

        this.loaderColor = 'green';
        this.isLoading = true;
        TelegramService.getMe(this.token)
          .then(function(bot) {
            ApiService.createBot(this.user, this.token, this.structure)
              .then(function() {
                bot['token'] = this.token
                this.bots.push(bot);
                this.$store.commit('setBots', this.bots)
                //this.token = "";
                this.$dialog.alert(this.CREATE_MSG)
                this.$router.push({ name: 'editor', params: { token: this.token }})
              }.bind(this))
              .catch(function(response) {
                this.$dialog.alert(response.description)
              }.bind(this))
              .finally(function() {
                this.isLoading = false;
              }.bind(this))
          }.bind(this))
          .catch(function(msg) {
            this.isLoading = false;
            this.$dialog.alert(msg).then(function() {
              this.$refs.token.focus();
              this.$refs.token.value = "";
            }.bind(this));
          }.bind(this))
      }
    },
    deleteBot(token) {
      this.$dialog
        .confirm("If you Delete This Bot, It'll Be Gone Forever.")
        .then(async function() {
          this.loaderColor = 'red';
          this.isLoading = true;
          ApiService.deleteBot(this.user, token)
            .then(function() {
              this.bots = this.bots.filter(bot => bot.token != token);
              this.$store.commit('setBots', this.bots)
            }.bind(this))
            .catch(function(msg) {
              this.$dialog.alert(msg)
            }.bind(this))
            .finally(function() {
              this.isLoading = false;
              TelegramService.setMyCommands(token, {
                commands: []
              })
            }.bind(this))
        }.bind(this))
    },
    getBots() {
      if(this.bots.length == 0){
        this.loaderColor = 'black';
        this.isLoading = true;
        ApiService.getUser(this.user)
          .then(function(result) {
            result.bots.forEach(getMe.bind(this));
            this.$store.commit('setBots', this.bots)
          }.bind(this))
          .catch(function(response) {
            this.$dialog.alert(response.description)
          }.bind(this))
          .finally(function() {
            this.isLoading = false;
          }.bind(this))
        }

      async function getMe(token) {
        TelegramService.getMe(token)
          .then(function(bot) {
            bot['token'] = token
            this.bots.push(bot);
          }.bind(this))
          .catch(function() {
            this.bots.push({
              token: token,
              first_name: "Bot deleted from Telegram",
              username: "Bot deleted from Telegram"
            })
            this.$dialog.alert("Bot not found : " + token)
          }.bind(this))
      }
    },
  },
  mounted() {
    this.getBots()
  }
}
</script>
